import { useEffect, useState } from "react";
import headerLeftLogo from "../../../headerLeftLogo.png"
import headerRightLogo from "../../../headerRightLogo.png"
import footerImage from "../../../footerImage.png"
import headerImage from "../../../headerFullImage.png"
import "./QuotePDFNewCommonStyleSheet.scss";
import FetchData, { GetOne } from "../../../providers/dataProvider";
import { useLocation } from "react-router-dom";
import { CheckNull, PriceFormat, formatDate, numberToWords, FormatValueDecimal, getStorageData, calculateNetPrice } from "../../../utils/Validate";
import { ConvertFromBase } from "../../../utils/Validate";
import moment from "moment";
import NewTermsAndConditions from "./NewTermsAndConditions";
import usePrintWithFilename from "../../../hooks/usePrintWithFilename";

const QuotePDFNewSummary = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const location = useLocation();
    const [customerObj, setCustomer] = useState(null);
    const [quotePDFDetails, setQuotePDFDetails] = useState(null);
    const [projectObj, setProject] = useState(null);
    const [distributorImage, setDistributorImage] = useState(null);
    const queryParams = new URLSearchParams(location.search);
    const quoteId = queryParams.get("id"); // Get the 'id' from query string
    const [listData, setListData] = useState([])

    const { data: currencyList } = FetchData("currency");
    const { data: assignedEngineerList } = FetchData("userprofile");
    const { data: deliveryTermsList } = FetchData("deliveryterms");
    const { data: paymentTermsList } = FetchData("paymentterms");
    const { data: countryList } = FetchData("country");
    const { data: distributorList } = FetchData("distributor");

    const salesEngObj = assignedEngineerList?.find((ob) => ob?.identityId == quotePDFDetails?.data?.salesEngineerId)
    const currencyDetail = currencyList?.find(item => item?.id === quotePDFDetails?.data?.currencyId)

    // Quotation distributor currency = base currency
    const quoteDistributor = distributorList?.find(item => item?.id === quotePDFDetails?.data?.distributorId);
    const baseCurrency = currencyList?.find(item => item?.id === quoteDistributor?.currencyId);

    const CurrencyConvertion = (amount, rate, currency) =>
        ConvertFromBase(amount, rate, currency, baseCurrency);


    const totalNetPrice = quotePDFDetails?.data?.products?.reduce((sum, item) => {
        return sum + calculateNetPrice(item);
    }, 0) || 0;

    const totalDdp = quotePDFDetails?.data?.products?.reduce((sum, item) => {
        return sum + (parseFloat(item?.totalDdp) || 0);
    }, 0) || 0;

    const netPriceRounded = parseFloat(totalDdp.toFixed(2));

    const taxAmount = (() => {
        const data = quotePDFDetails?.data;
        if (!data) return 0;
        if (data?.tax > 0) return data.tax * 1;
        if (data?.taxPercentage > 0) return totalDdp * (data.taxPercentage / 100);
        return 0;
    })();

    const specialChargesValue = Number(quotePDFDetails?.data?.specialCharges) || 0;

    const grandTotal = parseFloat((totalDdp + specialChargesValue + taxAmount).toFixed(2));
    const showTaxRow = quotePDFDetails?.data?.tax > 0 || quotePDFDetails?.data?.taxPercentage > 0;
    const showGrandTotalRow = grandTotal > 0;
    const summaryRowCount = 1 + (specialChargesValue > 0 ? 1 : 0) + (showTaxRow ? 1 : 0) + (showGrandTotalRow ? 1 : 0);
    const handlePrint = usePrintWithFilename(quotePDFDetails?.data?.quoteReference);


    useEffect(() => {
        if (quoteId) {
            GetOne("quotation", { id: quoteId }, setQuotePDFDetails);
        }
    }, [quoteId]);

    useEffect(() => {
        if (salesEngObj?.id) {
            GetOne("userprofile", { id: salesEngObj?.id }, setListData)
        }
    }, [salesEngObj]);

    useEffect(() => {
        if (quotePDFDetails?.data) {
            GetOne("Customer", { id: quotePDFDetails?.data?.customerId }, setCustomer);
            GetOne("project", { id: quotePDFDetails?.data?.projectId }, setProject);
        }
    }, [quotePDFDetails])


    useEffect(() => {
        const userProf = getStorageData();
        const userProfId = userProf?.userCompanyId;
        const distributorUrl = distributorList?.find(item => item?.id === userProfId)
        setDistributorImage({ distributorUrl: distributorUrl, userProf: userProf })
    }, [distributorList])

    useEffect(() => {
        const updatePageNumbers = () => {
            const total = Math.ceil(document.body.scrollHeight / window.innerHeight);
            setTotalPages(total);
        };

        window.addEventListener("resize", updatePageNumbers);
        updatePageNumbers(); // Initial calculation

        return () => window.removeEventListener("resize", updatePageNumbers);
    }, []);

    const groupedProducts = (() => {
        const products = quotePDFDetails?.data?.products || [];
        const groups = {};

        products.forEach((item) => {
            const key = `${item?.groupName}__${item?.productName}`;

            if (!groups[key]) {
                groups[key] = {
                    groupName: item?.groupName,
                    productName: item?.productName,
                    quoteQuantity: 0,
                    totalDdp: 0,
                };
            }

            groups[key].quoteQuantity += parseFloat(item?.quoteQuantity) || 0;
            groups[key].totalDdp += parseFloat(item?.totalDdp) || 0;
        });

        return Object.values(groups);
    })();

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-12 text-end">
                        <div className="print-btn-container">
                            <button
                                onClick={handlePrint}
                                disabled={!quotePDFDetails?.data}
                                className="btn pdf-print-btn my-2"
                            >
                                Export to PDF
                            </button>
                        </div>
                    </div>
                    <div className="col-12">
                        <table className="bg-white">
                            <thead>
                                <tr>
                                    <td className="boder-none p-0">
                                        <div className="page-header position-relative">
                                            <table className="quotation-summary-pdf-table-head w-100">
                                                <tr>
                                                    <th className="text-start pt-0 pl-0 position-relative">
                                                        <img className="w-100" src={distributorImage?.userProf?.userType === 2 ? distributorImage?.distributorUrl?.headerUrl : headerImage} />
                                                        <div className="quotation-text">QUOTATION</div>
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </thead>

                            <tbody className="page-content">
                                <tr>
                                    <td className="boder-none">
                                        <div className="page">
                                            <table className="customer-details-table">
                                                <tbody>
                                                    <tr>
                                                        <td className="w-50 border-right">
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Customer <span className="float-right">:</span></td>
                                                                        <td>{customerObj?.data?.customerName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Address <span className="float-right">:</span></td>
                                                                        <td>{quotePDFDetails?.data?.customerAddress}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact Person <span className="float-right">:</span></td>
                                                                        <td>{quotePDFDetails?.data?.contactPerson}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact # <span className="float-right">:</span></td>
                                                                        <td>{quotePDFDetails?.data?.phone}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Quote Currency <span className="float-right">:</span></td>
                                                                        <td>{currencyDetail?.shortCode}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>

                                                        {/* Second Column (Quote Details) */}
                                                        <td className="w-50">
                                                            <table className="w-100">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Quote Ref <span className="float-right">:</span></td>
                                                                        <td>{quotePDFDetails?.data?.quoteReference}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Date <span className="float-right">:</span></td>
                                                                        <td>{formatDate(quotePDFDetails?.data?.createdAt, "")}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Customer Email <span className="float-right">:</span></td>
                                                                        <td>{quotePDFDetails?.data?.emailAddress}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Sales Eng <span className="float-right">:</span></td>
                                                                        <td>{salesEngObj?.firstName + " " + salesEngObj?.lastName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact <span className="float-right">:</span></td>
                                                                        <td>{listData?.data?.phone}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="border-top" colspan="2">
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="w-12">Project<span className="float-right">:</span></td>
                                                                        <td colspan="4">{projectObj?.data?.projectName}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="w-100 mt-1 mb-1 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-0"> Dear Sir/Madam, <br />
                                                            We thank you for your enquiry and are pleased to submit our proposal as follows:
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="product-details-table w-100">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th className="border-right">Product Group</th>
                                                        <th className="border-right text-center">Model</th>
                                                        <th className="border-right text-center">Qty</th>
                                                        <th className="text-center w-15">Total Price ({currencyDetail?.shortCode})</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        groupedProducts?.map((item, index) => {
                                                            const itemNetPrice = item?.totalDdp
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td className="border-right">{item?.groupName}</td>
                                                                    <td className="border-right text-center"> {item?.productName}</td>
                                                                    <td className="border-right text-center">{item?.quoteQuantity}</td>
                                                                    <td className="text-right">
                                                                        {FormatValueDecimal(
                                                                            CurrencyConvertion(itemNetPrice, quotePDFDetails?.data?.conversionRate, currencyDetail)
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                            <table className="net-price-table w-100 mt-5px">
                                                <tbody>
                                                    <tr>
                                                        <td className="quote-amount-words" rowSpan={summaryRowCount}>
                                                            <strong className="quote-amount-words-title">Amount in words</strong>
                                                            <span className="quote-amount-words-value">
                                                                {numberToWords(CurrencyConvertion(grandTotal, quotePDFDetails?.data?.conversionRate, currencyDetail), currencyDetail)}
                                                            </span>
                                                        </td>

                                                        <td className="quote-summary-item">                                                        <span>Net Price</span>
                                                            <span className="ml-1">:</span>
                                                            <span className="ml-1">{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(netPriceRounded, quotePDFDetails?.data?.conversionRate, currencyDetail))}</span>

                                                        </td>                                                    </tr>
                                                    {specialChargesValue > 0 && (
                                                        <tr>
                                                            <td className="quote-summary-item">
                                                                <span>Color Charges</span>
                                                                <span className="ml-1">:</span>
                                                                <span className="ml-1">{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(specialChargesValue, quotePDFDetails?.data?.conversionRate, currencyDetail))}</span>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {showTaxRow && (<tr>
                                                        <td className="quote-summary-item">
                                                            <span>Taxes / VAT {quotePDFDetails?.data?.tax > 0 ? "" : "@ " + quotePDFDetails?.data.taxPercentage + "%"}</span>
                                                            <span className="ml-1">:</span>
                                                            <span className="ml-1">{currencyDetail?.shortCode} {quotePDFDetails?.data?.tax > 0 ? FormatValueDecimal(CurrencyConvertion(quotePDFDetails?.data?.tax, quotePDFDetails?.data?.conversionRate, currencyDetail)) :
                                                                FormatValueDecimal(CurrencyConvertion(((((quotePDFDetails?.data?.totalLandedCost * 1) / (1 - (quotePDFDetails?.data?.salesMarginPercentage / 100))) * 1) * ((quotePDFDetails?.data?.taxPercentage * 1) / 100)), quotePDFDetails?.data?.conversionRate, currencyDetail))}</span>
                                                        </td>
                                                    </tr>)}

                                                    {showGrandTotalRow && (<tr>
                                                        <td className="quote-summary-item quote-summary-item--grand">
                                                            <span>Grand Total</span>
                                                            <span className="ml-1">:</span>
                                                            <span className="ml-1">{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(grandTotal, quotePDFDetails?.data?.conversionRate, currencyDetail))}</span>
                                                        </td>
                                                    </tr>)}
                                                </tbody>
                                            </table>
                                            <table className="terms-conditions-table w-100 mt-5px border-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start" colspan="2"> Terms & Conditions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="text-start">Payment Terms
                                                            <span className="float-right">:</span>
                                                        </td>
                                                        <td className="text-start">{quotePDFDetails?.data?.paymentTerms || paymentTermsList?.find(item => item?.id === quotePDFDetails?.data?.paymentTermId)?.paymentDescription}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Delivery Terms <span className="float-right">:</span></td>
                                                        <td className="text-start">{quotePDFDetails?.data?.deliveryTerms || deliveryTermsList?.find(item => item?.id === quotePDFDetails?.data?.deliveryTermId)?.deliveryDescription
                                                            || quotePDFDetails?.data?.destination}
                                                            {countryList?.find(country => country?.id === quotePDFDetails?.data?.destinationCountryId)?.name
                                                                && (countryList?.find(country => country?.id === quotePDFDetails?.data?.destinationCountryId)?.name)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Delivery Period <span className="float-right">:</span></td>
                                                        <td className="text-start">As per the project requirement</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Validity <span className="float-right">:</span></td>
                                                        <td className="text-start"> {quotePDFDetails?.data?.quoteValidity} days from the date hereof and thereafter subject to our written
                                                            confirmation.</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Warranty <span className="float-right">:</span></td>
                                                        <td className="text-start"> Goods manufactured by Jersey Manufacturing carry a standard warranty of 12
                                                            months from the date of supply,
                                                            against all manufacturing defects, subject to our warranty policy - (can be provided on
                                                            request).</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="w-100 mt-1 mb-1 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-0"> We once again thank you for the opportunity to quote for your requirement. Please feel free to contact us in case of any clarification. <br />
                                                            Thanking you and assuring you our best attention and services at all times.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="border-0 py-1 fs-13">
                                                            For, {quotePDFDetails?.data?.distributorName}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="signature-table w-100 mt-1 mb-1 border-0 mt-5">
                                                <tbody>
                                                    <tr>
                                                        <td className="text-center border-0"> Sales Engineer
                                                        </td>
                                                        <td className="text-center border-0">  Divisional manager</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="9" className="border-0 pb-0">
                                        <div className="page-footer-space"></div>
                                        <div className="page-quote-footer w-100">
                                            <table className="footer-quote-logo-table w-100 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="text-start border-0 pl-0">Quote Ref # : {quotePDFDetails?.data?.quoteReference}</td>
                                                        <td className="text-end border-0">{moment(new Date()).format("DD-MMM-YYYY hh:mm A")}</td>
                                                        <td className="text-end border-0 pr-40">QR/DR-N/2021 RDO</td>
                                                        {/* <td className="text-end border-0 pr-40">Page 1 of 15</td>  */}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                            <tfoot>
                                <tr>
                                    <td colspan="9" className="border-0">
                                        <div className="page-footer w-100">
                                            <table className="footer-logo-table w-100 border-0">
                                                <tbody>
                                                    <tr className="border-top">
                                                        <th className="text-start pl-0 pr-0 border-0 pt-0 pb-0" colSpan="9">
                                                            <img src={distributorImage?.userProf?.userType === 2 ? distributorImage?.distributorUrl?.footerUrl : footerImage} alt="Footer Logo" className="footer-logo w-100" />
                                                        </th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <NewTermsAndConditions distributorImage={distributorImage} />
        </>
    );
};

export default QuotePDFNewSummary;
